import { SectionMessageAction } from '@atlaskit/section-message';
import React, { FC } from 'react';
import { translationKeys, useTranslation } from '../../../../../services/localization';
import { useHref } from 'react-router-dom';

export const LearnMoreAction: FC = () => {
  const { translate } = useTranslation();

  return (
    <SectionMessageAction
      onClick={() =>
        window.open(
          'https://support.atlassian.com/atlassian-account/docs/manage-your-email-and-notification-preferences/',
          '_blank',
        )
      }
    >
      {translate(translationKeys.NOTIFICATION_LEARN_MORE_BUTTON_LABEL)}
    </SectionMessageAction>
  );
};

export const SubscribeToAction = (props: {
  hid: string;
  subscriptionKey: string;
  onSubscribeCallback?: () => void;
}) => {
  const { translate, keyWithTitle } = useTranslation();
  const href = useHref('/');
  const subscribeToCallback = () => {
    const params = new URLSearchParams({
      hid: props.hid,
      subscribeKeys: props.subscriptionKey,
    });
    window.location.href = `${href}?${params.toString()}`;
    props.onSubscribeCallback?.();
  };
  return (
    <SectionMessageAction onClick={subscribeToCallback}>
      {translate(translationKeys.NOTIFICATION_SUBSCRIBE_TO_BUTTON_LABEL, {
        subscription: translate(keyWithTitle(props.subscriptionKey)) || '',
      })}
    </SectionMessageAction>
  );
};
